import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
export const EditGruppo: AnaColumn[] = [
  {
    itemType: "group", colCount: "2", data: [      
      {
        type: "button",  caption: "", 
        button:             
              { name: 'Full', class:'custom-button' , icon: 'checklist', hint: 'Abilita/Disabilita Controllo Completo', event: '1', location: 'top'},
      },
 
      { type: 'campo',disableOnUpdate:true, disabled:true,  hideOnEdit:true, dataField: "descrizioneuFunzioni", dataType: "", caption: "Funzione", width: "300" },

      { type: 'campo', allowSorting:false,
      caption:'Ins.',colAlignment:'center', dataField: "inserimento", dataType: "boolean"},

      { type: 'campo',allowSorting:false, caption:'Mod.',colAlignment:'center',dataField: "modifica", dataType: "boolean"},
      { type: 'campo',allowSorting:false, caption:'Canc.',colAlignment:'center',dataField: "cancellazione",dataType: "boolean" },
      { type: 'campo',allowSorting:false, caption:'Vis.',colAlignment:'center',dataField: "visualizzazione", dataType: "boolean",},
      { type: 'campo',allowSorting:false, caption:'Spec.',colAlignment:'center',dataField: "speciale", dataType: "boolean",},
    ]
  },
]
export const Gruppo: AnaColumn[] = [
    {
      itemType: "group", colCount: "2", colSpan:"2", data: [
        { type: 'campo', hideOnEdit:true, colVisible:false,visible:false, dataField: "id", dataType: ""},
        { type: 'campo', dataField: "descrizione", dataType: "",caption:'Descrizione'},
        { type: 'campo', dataField: "isAttivo", dataType: "boolean", caption:'Stato'},
      ]
    },
    /*{
      itemType: "group", colCount: "1", colSpan:'2',data: [
       {
          type: 'component', dataType: "", caption: "Permessi",
          colVisible: false,        
          dataField:'PermessiutentiComponent', // nome Componente
          visible:false,
          labelVisible: true,
          disableOnUpdate: true,
       }               
      ]
    },*/
  ]